import React from 'react';
import './Footer.css';
import {ReactComponent as FacebookLogo} from "../../../../assets/socialMedia/ic_facebook--circle.svg";
import {ReactComponent as InstagramLogo} from "../../../../assets/socialMedia/ic_instagram--circle.svg";
import {ReactComponent as LinkedinLogo} from "../../../../assets/socialMedia/ic_linkedin--circle.svg";
import {ReactComponent as EmailLogo} from "../../../../assets/socialMedia/ic_email--circle.svg";
import {ReactComponent as WhatsappLogo} from "../../../../assets/socialMedia/ic_whatsapp--circle.svg";
import {ReactComponent as TiktokLogo} from "../../../../assets/socialMedia/ic_tiktok--circle.svg";
import {ReactComponent as YoutubeLogo} from "../../../../assets/socialMedia/ic_youtube--circle.svg";
import { trackClick, getElementName } from "../../../../utils/analytics/analytics";
import { ANALYTICS_MODULES, ANALYTICS_SECTIONS, ANALYTICS_ELEMENT_TYPES } from "../../../../constants/analyticsConstants";

function Footer() {
    const openURL = (url, socialMediaName) => {
        trackClick({
            module: ANALYTICS_MODULES.LANDING,
            section: ANALYTICS_SECTIONS.LANDING_FOOTER,
            elementName: getElementName(ANALYTICS_ELEMENT_TYPES.ICON, ANALYTICS_SECTIONS.LANDING_FOOTER, socialMediaName),
            elementType: ANALYTICS_ELEMENT_TYPES.ICON
        });
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    return (
        <div className="clientes__footer__container">
            <div className="clientes__footer__bodyContainer">
                <h1 className="clientes__footer__title">¿Sos productor?</h1>
                <h2 className="clientes__footer__description">
                    Unite al equipo de polko a través de nuestra página{" "}
                    <a
                        href="https://www.polko.com.ar"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="clientes__footer__link"
                        onClick={() => {
                            trackClick({
                                module: ANALYTICS_MODULES.LANDING,
                                section: ANALYTICS_SECTIONS.LANDING_FOOTER,
                                elementName: getElementName(ANALYTICS_ELEMENT_TYPES.LINK, ANALYTICS_SECTIONS.LANDING_FOOTER, 'polko_web'),
                                elementType: ANALYTICS_ELEMENT_TYPES.LINK
                            });
                        }}
                    >
                        www.polko.com.ar
                    </a>
                </h2>
            </div>
            <div className="clientes__footer__bodyContainer">
                <h1 className="clientes__footer__title">¡Mantenete informado!</h1>
                <div className='clientes__footer__socialMedia'>
                    <FacebookLogo className='clientes__footer__socialMedia--icon'
                                  onClick={() => openURL('https://www.facebook.com/people/POLKO/100076895052641/', 'facebook')}/>
                    <YoutubeLogo className='clientes__footer__socialMedia--icon --stroke'
                                 onClick={() => openURL('https://youtube.com/@somospolko?si=EK9UD0xDAWFfLBUm', 'youtube')}/>
                    <InstagramLogo className='clientes__footer__socialMedia--icon'
                                   onClick={() => openURL('https://www.instagram.com/somospolko/', 'instagram')}/>
                    <TiktokLogo className='clientes__footer__socialMedia--icon --stroke'
                                onClick={() => openURL('https://www.tiktok.com/@somospolko', 'tiktok')}/>
                    <LinkedinLogo className='clientes__footer__socialMedia--icon'
                                  onClick={() => openURL('https://www.linkedin.com/company/polko-sas', 'linkedin')}/>
                    <EmailLogo className='clientes__footer__socialMedia--icon'
                               onClick={() => openURL('https://mail.google.com/mail/?view=cm&fs=1&to=consultas@polko.com.ar&subject=&body=¡Hola%20buenos%20días!%20Tengo%20una%20consulta', 'email')}/>
                    <WhatsappLogo className='clientes__footer__socialMedia--icon'
                                  onClick={() => openURL('https://wa.me/' + "3518687927" + '?text=¡Hola%20buenos%20días!%20Tengo%20una%20consulta', 'whatsapp')}/>
                </div>
            </div>
            <p className="clientes__footer__copyrightText">POLKO SAS® Copyright © 2024. Todos los derechos reservados.</p>
        </div>);
}

export default Footer;